import { throwError as observableThrowError } from 'rxjs';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { Logger } from '../logger.service';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

const logger: Logger = new Logger('Backend');

const routes = {
  bakFindOrderPriceInBackend: '/api/bakFindOrderPriceInBackend',
};

@Injectable({
  providedIn: 'root',
})
export class BackendService {
  private http = inject(HttpClient);
  constructor() { }

  public findOrderPriceInBackend(subscriptionId: string): any {
    const body = {
      subscriptionId: subscriptionId,
    };
    return this.http
      .post<Response>(routes.bakFindOrderPriceInBackend, body, {})
      .pipe(
        map((res: Response) => res),
        catchError((error: any) => {
          logger.error(error);
          return observableThrowError(() => error);
        })
      );
  }
}
